import Vue from 'vue';
import Component from 'vue-class-component';
import { Status } from '@/models/status.model';
import { STORE } from '@/core/store/core.store';
import { LocalStorageService } from '@/services/local-storage.service';
import { TEACHER_PORTAL_KEYS } from '@/content/pages/teacher-portal/values/teacher-portal.values';
import { HOMEWORKS_EVENTS } from '@/homework/values/homeworks.values';
import Course from '@/content/models/course.model';

@Component({
  components:{
    EdListHomeworkLoading: () => import(/* EdListHomeworkLoading */'../ed-list-homework-loading/ed-list-homework-loading.vue'),
    EdHomeworkWidgetCourseSection: () => import(/* EdHomeworkWidgetCourseSection */'../ed-homework-widget-course-section/ed-homework-widget-course-section.vue'),
  }
})
export default class EdListHomeworkSections extends Vue {

  public coursesStatus: Status = new Status();
  public moreCoursesStatus: Status = new Status();

  get courses() {
    return this.$store.state.HomeworksStore.teacherWidgetHomeworksSection.courses.content;
  }

  get hasMoreCourses() {
    return this.$store.state.HomeworksStore.teacherWidgetHomeworksSection.courses.more;
  }

  async getCourses(status: Status , reload: boolean = false) {
    try {
      status.setLoading();
      let courseId = LocalStorageService.getItem(TEACHER_PORTAL_KEYS.TASKS_COURSE_ID);
      let sectionId = LocalStorageService.getItem(TEACHER_PORTAL_KEYS.TASKS_HOMEWORK_ID);
      let classId = null;
      if(courseId && sectionId) {
        let course: Course = this.$store.state.CourseStore.courses.content.find(c => c.id == courseId);
        if(course) classId = course.classId;
      }
      await this.$store.dispatch(
        STORE.HOMEWORKS.ACTIONS.GET_TEACHER_WIDGET_HOMEWORKS_BY_SECTIONS,
        { courseId, sectionId, classId , reload }
      );
      status.setLoad();
    } catch(err) {
      status.setError();
    }
  }

  getMoreCourses() {
    this.getCourses(this.moreCoursesStatus);
  }

  created() {
    if(!this.$store.state.HomeworksStore.teacherWidgetHomeworksSection.firstLoad) { 
      this.getCourses(this.coursesStatus);
    } else {
      this.coursesStatus.setLoad();
    }
    this.$edEventBus.$on(HOMEWORKS_EVENTS.RELOAD_TASKS_BY_SECTIONS_TAB, (reload: boolean) => {
      this.getCourses(this.coursesStatus, reload);
    });
  }

  beforeDestroy() {
    this.$edEventBus.$off(HOMEWORKS_EVENTS.RELOAD_TASKS_BY_SECTIONS_TAB, (reload: boolean) => {
      this.getCourses(this.coursesStatus, reload);
    });
  }

}